import axios from 'axios';
import qs from 'qs';
import * as QueryString from 'querystring';
axios.defaults.withCredentials = true;
export function GetSever(baseURL, param) {
  return new Promise((resolve, reject) => {
    axios
      .get(
        baseURL,
        { params: param },
        {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Access-Control-Allow-Credentials': true,
            'Access-Control-Allow-Headers': 'Content-Type, Content-Length, Authorization, Accept, X-Requested-With , yourHeaderFeild',
            'Access-Control-Allow-Methods': 'PUT, POST, GET, DELETE, OPTIONS' //设置方法
          },
          emulateJSON: false,
          credentials: true, //携带cookie跨域
          withCredentials: true,
          timeout: 1000 * 30
        }
      )
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error.data);
      });
  });
}
export function PostSever(baseURL, param) {
  let paramData = {};
  if (JSON.stringify(param) != '{}') {
    paramData = param;
  }
  return new Promise((resolve, reject) => {
    axios
      .post(baseURL, qs.stringify(paramData), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        withCredentials: true,
        timeout: 1000 * 30
      })
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error.data);
      });
  });
}
export function GwPostSever(url, param) {
  let paramData = {};
  if (param && JSON.stringify(param) !== '{}') {
    paramData = `reqData=${encodeURIComponent(JSON.stringify(param))}`;
  }
  return new Promise((resolve, reject) => {
    axios
      .post(url, paramData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        withCredentials: true,
        timeout: 1000 * 30
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}
export function getJSONPData(uri, data) {
  return new Promise((resolve, reject) => {
    let callbackName = 'callbackName' + new Date().getTime();
    let query = null;
    if (data === null) {
      query = {
        callback: callbackName
      };
    } else {
      query = data;
      query.callback = callbackName;
    }

    const url = uri + '?' + QueryString.stringify(query);
    const script = document.createElement('script');
    script.setAttribute('src', url);
    script.addEventListener('error', error => {
      script.remove();
      delete window[callbackName];
      const larkError = new Error('JSONP_LOAD_ERROR');
      larkError['data'] = error;
      reject(larkError);
    });
    document.body.appendChild(script);
    window[callbackName] = data => {
      resolve(data);
      script.remove();
      delete window[callbackName];
    };
  });
}
